import React from 'react';
import "../css/Header.css";

export default function Header() {
    return (
        <div id="headerComponent">
            <nav className="pds-navigationPrimary-horizontal">
                <div className="pds-navigationPrimary-container container">
                    <div className="pds-navigationPrimary-logo">
                        <a className="pds-navigationPrimary-logo-link pds-link-unstyled" href="www.google.com" aria-label="Principal Homepage"><img alt="" className="pds-imgLogoCompanyNameWhiteRetina" /></a>
                    </div>
                </div>
            </nav>
        </div>
    )
}